module.exports = {"id":"dp2_6l1q1","text":"Managing Digital Identity","instructions":"Why is it useful to manage your digital identity?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.6","questionType":"PickOne","random":true,"options":[{"id":"dp2_6l1q1-a1","text":"It helps control how you appear online","score":1.8},{"id":"dp2_6l1q1-a2","text":"It improves internet connection speed","score":0},{"id":"dp2_6l1q1-a3","text":"It increases device storage capacity","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.6/l1q1.json
// module id = 1089
// module chunks = 41